import moment from 'moment';

export const getFromToDate = (from, to) => {
    let fromDate =  moment(from).format('MMM DD');
    let toDate = moment(to).format('MMM DD');
    return `From ${fromDate} To ${toDate}`;
}